import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export interface NotificationButtonProps extends ButtonProps {}

/**
 * NotificationButton is a proxy component to <Button variant="outline" size="small" color="secondary" />
 */
export const NotificationButton: React.FC<NotificationButtonProps> = forwardRef((props, ref) => {
  return <Button ref={ref} variant="outlined" size="small" color="secondary" {...props} />;
});
